/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHerbalAnchorFlagData } from './herbal-anchor-flag.data';
import { IHerbalAnchorFlagProps } from './herbal-anchor-flag.props.autogenerated';

export interface IHerbalAnchorFlagViewProps extends IHerbalAnchorFlagProps<IHerbalAnchorFlagData> {}

/**
 *
 * HerbalAnchorFlag component
 * @extends {React.PureComponent<IHerbalAnchorFlagProps<IHerbalAnchorFlagData>>}
 */
class HerbalAnchorFlag extends React.PureComponent<IHerbalAnchorFlagProps<IHerbalAnchorFlagData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HerbalAnchorFlag;
